import { Link } from "react-router-dom";
import { Tag } from "antd";
import React from "react";
import config from "@/config";

export const CompanyCard = ({ index, company }) => {

    return (
        <Link
            to={`/cong-ty/${company.Pk}`}
            key={index}
            className="grid relative grid-cols-5 h-full items-center border border-gray-200 bg-gray-100 p-2 rounded-lg hover:shadow-lg hover:cursor-pointer"
            style={{
                padding: "0",
            }}
        >
            {/* Hình ảnh */}
            <div className="col-span-1 mb-14 lg:mb-0 p-2">
                <img
                    src={config.ImageConfig.getLogo(company.PhotoCompany)}
                    alt="company-logo"
                    className="rounded-lg lg:w-full w-56"
                />
            </div>

            {/* Nội dung */}
            <div className="col-span-4 p-4 flex flex-col justify-between w-full">
                <h2 className="text-lg font-bold overflow-ellipsis overflow-hidden lg:whitespace-normal whitespace-nowrap hover:text-cyan-600">
                    {company.CompanyName}
                </h2>
                <div className="flex my-2 flex-wrap gap-2 lg:w-full lg:flex-row">
                    <Tag color={"blue"}
                        className="text-gray-500">{company.LocationCompany}
                    </Tag>
                    <Tag color={"green"}
                        className="text-gray-500"> Có {company.totalJobs} việc làm
                    </Tag>
                </div>
            </div>
        </Link>
    )
}